export default "__VITE_ASSET__DQuEe1Rj__"